import {createSelector} from 'reselect';
import getAppliedGiftcards from './getAppliedGiftcards';
import getGiftcardFormData from './getGiftcardFormData';

export default isDiggecard => createSelector(
  [getAppliedGiftcards, getGiftcardFormData],
  (appliedGiftcards, giftcardFormData) => {
    if (isDiggecard) {
      return appliedGiftcards.find(giftcard => giftcard.cardNumber === giftcardFormData.giftcardNumber);
    }
    return appliedGiftcards.find(giftcard => giftcard.cardNumber === giftcardFormData.giftcardNumber && giftcard.cardPin === giftcardFormData.giftcardPin);
  },
);
